import AbstractClass from './CommonAbstractServices';
import { AwaitResponse } from '../../utils/MockUtils';

export default class CommonServices extends AbstractClass {
  static getBusinessHours() {
    return AwaitResponse([
      {
        open: '08:30:00',
        close: '20:00:00',
        day: 'Monday',
      },
      {
        open: '08:30:00',
        close: '20:00:00',
        day: 'Tuesday',
      },
      {
        open: '08:30:00',
        close: '20:00:00',
        day: 'Wednesday',
      },
      {
        open: '08:30:00',
        close: '20:00:00',
        day: 'Thursday',
      },
      {
        open: '08:30:00',
        close: '18:00:00',
        day: 'Friday',
      },
    ]);
  }

  static getSearchPrediction() {
    return AwaitResponse(['Defence Health', 'Join Defence Health']);
  }

  static uploadRebateFormPdf() {
    return AwaitResponse({
      "storageContainer": "documents",
      "fileName": "MemberPortal-Add-a-Rebate-30072024.pdf",
      "etag": "\"0x8DCB040BED98323\"",
      "blobName": "1099418/MemberPortal-Add-a-Rebate-30072024.pdf"
    });
  }
}
